import { getApiClient, signOut } from 'api/apiClient'
import { API_ROUTES } from 'constants/apiRoutesConstants'

import { PRICES_SELECTED_PLAN_COOKIE } from '@/constants'
import { deleteCookieClient } from '@/utils/client'

/**
 * Ends the session. Telling the server is best effort — an expired or already
 * invalidated token must still log the user out locally, so the local session
 * is cleared regardless of how the request resolves.
 */
export const logOut = async () => {
	try {
		await getApiClient().post(
			API_ROUTES.auth.logout,
			{},
			{ withCredentials: true },
		)
	} catch (error) {
		console.warn('Logout request failed', error)
	}

	deleteCookieClient(PRICES_SELECTED_PLAN_COOKIE)

	try {
		await signOut({ isRedirecting: true })
	} catch (error) {
		console.warn('Clearing the local session failed', error)
		window.location.href = '/'
	}
}
